import api from './api';

const logisticsService = {
  // Freight requests
  getFreightRequests: (params) => api.get('/freight', { params }),
  getFreightRequest: (id) => api.get(`/freight/${id}`),
  createFreightRequest: (data) => api.post('/freight', data),
  acceptFreightRequest: (id) => api.post(`/freight/${id}/accept`),
  rejectFreightRequest: (id, reason) =>
    api.post(`/freight/${id}/reject`, { reason }),

  // Shipments
  getShipments: (params) => api.get('/shipments', { params }),
  getShipment: (id) => api.get(`/shipments/${id}`),
  updateShipmentStatus: (id, status, data) =>
    api.put(`/shipments/${id}/status`, { status, ...data }),
  getShipmentTracking: (id) => api.get(`/shipments/${id}/tracking`),

  // POD (Proof of Delivery)
  uploadPOD: (shipmentId, formData) =>
    api.post(`/shipments/${shipmentId}/pod`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  getPOD: (shipmentId) => api.get(`/shipments/${shipmentId}/pod`),
  confirmPOD: (shipmentId) => api.post(`/shipments/${shipmentId}/pod/confirm`),

  // Earnings
  getEarnings: (params) => api.get('/earnings', { params }),
  getEarningsSummary: () => api.get('/earnings/summary'),
};

export default logisticsService;
